import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function SalesSubmitSuccess() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[calc(100vh-60px)] bg-gray-50">
      <div className="h-[100px] bg-gradient-to-r from-theme-1/95 to-theme-2/95 text-white relative">
        <div aria-hidden className="absolute inset-0 bg-texture-white opacity-20 pointer-events-none" />
        <div className="relative z-10 h-full px-4 pt-3">
          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={() => navigate("/app/sales")}
              className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center"
              aria-label="Back"
            >
              <ArrowLeft size={24} className="text-white" />
            </button>
            <div className="text-[18px] font-semibold">Sales</div>
            <div className="w-10 h-10" />
          </div>
        </div>
      </div>

      <div className="px-4 py-6 min-h-[calc(100vh-160px)] flex items-start justify-center pt-[162px]">
        <div className="w-full rounded-xl border border-green-200 bg-white p-5 shadow-[0_2px_10px_rgba(0,0,0,0.06)]">
          <div className="flex items-center justify-center gap-2 text-green-700">
            <CheckCircle2 size={20} />
            <div className="text-base font-semibold">Submission Successful</div>
          </div>
          <div className="mt-3 text-sm text-slate-700 text-center">
            Bank-in proof and sales data submitted successfully.
          </div>

          <button
            type="button"
            className="mt-5 w-full rounded-xl bg-primary text-white py-3 text-sm font-semibold"
            onClick={() => navigate("/app/sales")}
          >
            Back to Sales
          </button>
        </div>
      </div>
    </div>
  );
}

